import { useReducer } from 'react';

const initialState = {
  isOpen: false
};

const ACTION_TYPES = {
  OPEN_HOLD_REVIEW_DIALOG: 'OPEN_HOLD_REVIEW_DIALOG',
  CLOSE_HOLD_REVIEW_DIALOG: 'CLOSE_HOLD_REVIEW_DIALOG'
};

const ACTIONS = {
  openHoldReviewDialog: () => ({
    type: ACTION_TYPES.OPEN_HOLD_REVIEW_DIALOG
  }),
  closeHoldReviewDialog: () => ({
    type: ACTION_TYPES.CLOSE_HOLD_REVIEW_DIALOG
  })
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.OPEN_HOLD_REVIEW_DIALOG: {
      return {
        isOpen: true
      };
    }

    case ACTION_TYPES.CLOSE_HOLD_REVIEW_DIALOG: {
      return {
        isOpen: false
      };
    }

    default: {
      throw Error('useHoldReviewDialog reducer should never hit default');
    }
  }
};

const useHoldReviewDialog = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const open = () =>
    dispatch(
      ACTIONS.openHoldReviewDialog()
    );

  const close = () => dispatch(ACTIONS.closeHoldReviewDialog());

  const boundActions = {
    open,
    close
  };

  return [state, boundActions];
};

export default useHoldReviewDialog;
